import {
  userLoginAPI,
  verifyUserAPI,
  getUserListApi,
  registerUserAPI,
  setNewPasswordUserAPI,
  forgotPasswordUserAPI,
  resendVerifyCodeUserAPI,
} from "../services/user.service";
// import { saveLastLoginUser } from "@/utils/utils";
import { createAlert } from "./alertUtils";

export const loginUserUtils = async (payload, navigate, set) => {
  try {
    set({ isLoading: true });

    // Make the actual API call
    const response = await userLoginAPI(payload);

    if (response?.data.isSuccess) {
      const userData = response?.data?.body;

      // Update state with the user's data and token
      set({
        token: userData.access_token,
        user: userData.user,
        subscription_status: userData.subscriptionStatus,
      });

      // Save the user's login information if 'remember me' is checked
      if (payload.remember) {
        const userEmail = userData.user?.email;
        const profileImage = userData.user?.profile_picture_url;
        const userName = userData.user.first_name || userEmail.split("@")[0];
        saveLastLoginUser({
          email: userEmail,
          displayName: userName,
          image: profileImage,
        });
      }

      // If the user is verified, redirect to the appropriate route based on the role
      if (userData?.user?.is_verify) {
        const notification = {
          title: "Login",
          titleArabic: "تسجيل الدخول",
          body: "Login successful.",
          bodyArabic: "تم تسجيل الدخول بنجاح.",
        };
        createAlert({
          type: "success",
          title: " response?.data?.data?.notification?.title",
          message: "response?.data?.data?.notification?.body",
          notification,
          status: true,
        });
      } else if (!userData?.user?.is_verify) {
        // set({ isSignUp: true });
        // setEmail(userData?.user.email);
        navigate("/verify-code");
        set({ email: userData?.user.email });
      }
    } else {
      createAlert({
        type: "error",
        title: "",
        message: response.data.message,
        notification: {
          title: response.data.message,
          body: response.data.message,
          titleArabic: response.data.message,
          bodyArabic: response.data.message,
        },
        status: true,
      });
      // Handle unsuccessful login here, maybe show an error message or alert
      console.error("Login failed: Invalid credentials or other issues.");
    }
  } catch (error) {
    createAlert({
      type: "error",
      title: "",
      message: error?.response?.data?.message,
      notification: {
        title: error?.response?.data?.message,
        body: error?.response?.data?.message,
        titleArabic: error?.response?.data?.message,
        bodyArabic: error?.response?.data?.message,
      },
      status: true,
    });
    console.error("Login failed:", error);
  } finally {
    // Ensure that isLoading is set to false after completion
    set({ isLoading: false });
  }
};
export const signUpUser = async ({ data, router, lang }, set) => {
  try {
    // Set loading state to true
    set({ isLoading: true });

    // Call the API to register the user
    const response = await registerUserAPI(data);

    // Hide forgot password state
    set({ isForgotPassword: false });

    if (response.data.isSuccess) {
      set({ isSignUp: true });
      set({ isForgotPassword: false });
      set({ email: data.email });
    } else if (response.data.isSuccess === false) {
      // Handle error by showing an alert
      //   createAlert({
      //     type: "error",
      //     title: "Registration Failed",
      //     message: response.data.message,
      //     notification: {
      //       title: response.data.message,
      //       body: response.data.message,
      //     },
      //     status: true,
      //   });
    }
  } catch (error) {
    console.log("🚀 ~ registerUser ~ error:", error);
    // Handle error (you can use a utility to show a notification or log the error)
  } finally {
    // Set loading state to false after the process
    set({ isLoading: false });
  }
};

export const verifyCodeUtils = async ({
  data,
  router,
  lang,
  isForgotPassword,
  set,
}) => {
  try {
    set({ isVerifyLoading: true });

    // Call API to verify the code
    const response = await verifyUserAPI(data);

    if (response.data.isSuccess) {
      const userData = response.data;
      userData.token = response?.data?.access_token;

      if (router && isForgotPassword) {
        set({ token: userData.token, user: userData.user }); // Update token in the state
        // router.push(`/${lang}/auth/create-password`);
      } else {
        set({ token: userData.token, user: userData.user }); // Update token in the state
        // router.push(`/${lang}/dashboard`);
      }
      //   createAlert({
      //     type: "success",
      //     title: "",
      //     message: response.data.message,
      //     notification: {
      //       title: response.data.message,
      //       body: response.data.message,
      //       titleArabic: response.data.message,
      //       bodyArabic: response.data.message,
      //     },
      //     status: true,
      //   });
    } else {
      //   createAlert({
      //     type: "error",
      //     title: "",
      //     message: response.data.message,
      //     notification: {
      //       title: response.data.message,
      //       body: response.data.message,
      //       titleArabic: response.data.message,
      //       bodyArabic: response.data.message,
      //     },
      //     status: true,
      //   });
    }
  } catch (error) {
    console.error("Verification failed:", error);
  } finally {
    set({ isVerifyLoading: false });
  }
};
export const resendVerifyCodeUtils = async ({ data, lang, set }) => {
  try {
    const response = await resendVerifyCodeUserAPI(data);

    if (response.data.isSuccess) {
      // You can handle any further logic if needed, e.g., updating state, showing success messages, etc.
      console.log("Verification code resent successfully.");
      //   createAlert({
      //     type: "success",
      //     title: "",
      //     message: response.data.message,
      //     notification: {
      //       title: response.data.message,
      //       body: response.data.message,
      //       titleArabic: response.data.message,
      //       bodyArabic: response.data.message,
      //     },
      //     status: true,
      //   });
    }
  } catch (error) {
    console.log("Error resending verification code:", error);
  }
};
export const forgotPasswordUtils = async ({ data, router, lang, set }) => {
  try {
    set({ isLoading: true });

    const response = await forgotPasswordUserAPI(data);

    if (response.data.isSuccess) {
      set({ isForgotPassword: true });
      set({ isSignUp: false });
      set({ email: data.email });
      //   createAlert({
      //     type: "success",
      //     title: "Registration Failed",
      //     message: response.data.message,
      //     notification: {
      //       title: response.data.message,
      //       body: response.data.message,
      //       titleArabic: response.data.message,
      //       bodyArabic: response.data.message,
      //     },
      //     status: true,
      //   });
      if (router) {
        router.push(`/${lang}/auth/verify-password`);
      }
    } else {
      //   createAlert({
      //     type: "error",
      //     title: "Error",
      //     message: response.data.message,
      //     notification: {
      //       title: response.data.message,
      //       body: response.data.message,
      //       titleArabic: response.data.message,
      //       bodyArabic: response.data.message,
      //     },
      //     status: true,
      //   });
    }
  } catch (error) {
    console.log("Error with forgot password:", error);
  } finally {
    set({ isLoading: false });
  }
};
export const resetPasswordUtils = async ({ data, router, lang, set }) => {
  try {
    set({ isLoading: true });

    const response = await setNewPasswordUserAPI(data);

    if (response.data.isSuccess) {
      set({ isSignUp: false });
      set({ isForgotPassword: false });

      if (router) {
        router.push(`/${lang}/auth/reset-password`);
      }
    }
  } catch (error) {
    console.log("Error with resetting password:", error);
  } finally {
    set({ isLoading: false });
  }
};

export const getUsersList = async (payload, set) => {
  try {
    set({ isLoading: true });
    const response = await getUserListApi(payload);

    if (response?.data?.isSuccess) {
      set({
        list: response?.data?.body?.data,
        pagination: response?.data?.body?.pagination,
      }); // Save quote list to state
    } else {
      //   createAlert({
      //     type: "error",
      //     title: "Error fetching user",
      //     message: response.data.message || "Failed to fetch user",
      //     status: true,
      //   });
      set({
        list: [],
        pagination: { limit: 10, page: 1, totalCount: 0, totalPages: 0 },
      });
    }
  } catch (error) {
    console.error("Error fetching user:", error);
    // createAlert({
    //   type: "error",
    //   title: "Error",
    //   message: "An error occurred while fetching user.",
    //   status: true,
    // });
  } finally {
    set({ isLoading: false });
  }
};

export const setLogout = (set) => {
  set({
    token: "",
    user: null,
    subscription_status: null,
    isVerifyLoading: false,
    isLoading: false,
    isSignUp: false,
    isForgotPassword: false,
    email: "",
  });
};
export function saveLastLoginUser(newUser) {
  const usersJSON = localStorage.getItem("lastLoginUsers");
  let users = usersJSON ? JSON.parse(usersJSON) : [];

  const existingIndex = users.findIndex((u) => u.email === newUser.email);
  if (existingIndex >= 0) {
    users[existingIndex] = newUser; // update if changed
  } else {
    users.push(newUser);
  }
  localStorage.setItem("lastLoginUsers", JSON.stringify(users));
}
